export const LAYOUT = {
  heightResolution: '600px',
  topMenuHeight: '91px',
  bottomMenuHeight: '76px',
};

export const roundCorner = '6px';
export const fontSize = '20px';
export const proteinConcentrationColor = '#f7a246';
export const proteinConcentrationUnactiveColor = 'rgb(250, 207, 160)';
export const primaryBackgroundColor = '#373435';

// ----- BUTTON SIZE
export const ButtonSize = {
  defaultButtonHeight: '48px',
};

// ----- BUTTON COLOR
export const ButtonColor = {
  defaultButtonColor: '#828282',
  secondaryButtonBackgroundColorDisable: '#838383',
  secondaryButtonColorDisabled: '#82828285',
  buttonTextColor: 'white',
  buttonColorBackgroundDisable: '#CACACA',
  buttonTextColorDisable: '#9E9E9E',
};
